import { TABLA_DETALLE_POR_CEREAL_LINEA_3 } from '../../../../../config/tables'
import { COLUMNS_DETALLE_POR_CEREAL_LINEA_3, COLUMNS_DETALLE_POR_CEREAL_LINEA_3_TO_PRINT } from './constantesDetallePorCerealLinea3'
import { TablaDetallePorCerealLinea3Service } from '../../../../../models/movimiento/distribucionDetallePorCereal/Tabla_detalle_por_cereal_linea_3'
import { pdfCustomToolbarGenerator } from '../../../../../models/tools/generarPdf'

export function actualizarDatosParaMuiTable () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_DETALLE_POR_CEREAL_LINEA_3
    })
    const promiseTablaDetallePorCerealLinea3 = TablaDetallePorCerealLinea3Service.getDataTablaDetallePorCerealLinea3()
    const promiseTablaDetallePorCerealLinea3Total = TablaDetallePorCerealLinea3Service.getDataTablaDetallePorCerealLinea3Total()
    Promise.all([promiseTablaDetallePorCerealLinea3, promiseTablaDetallePorCerealLinea3Total]).then(callback)
    function callback (dataArray) {
      const dataCombinada = dataArray[0].filas || []
      const filaTotalArreglada = dataArray[1].filas[0]
      filaTotalArreglada['cereal'] = 'Total'
      dataCombinada.push(filaTotalArreglada)
      const customToolbar = pdfCustomToolbarGenerator(
        'Distribución Por Cereal Sector 3',
        dataCombinada,
        COLUMNS_DETALLE_POR_CEREAL_LINEA_3_TO_PRINT,
        'portrait')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_DETALLE_POR_CEREAL_LINEA_3,
          data: dataCombinada,
          title: `Distribución Por Cereal Sector 3`,
          isLoading: false,
          fixed2Decimales: true,
          extraOptions: { customToolbar, print: false, pagination: false }
        },
        id: TABLA_DETALLE_POR_CEREAL_LINEA_3
      })
    }
  }
}
